export const GENDER_ENUM = {
    FEMALE:'FU',
    MALE:'MU',
    UNISEX: 'U'
}